class CartHover {
  constructor(root) {
    this.root = root;
    this.panel = root.querySelector('[data-cart-hover-panel]');
    this.url = root.getAttribute('data-cart-hover-url');

    root.addEventListener('mouseenter', () => this.refresh());
    document.addEventListener('cart-updated', () => this.refresh());
  }

  refresh() {
    if (!this.url) return;
    fetch(this.url, { headers: { Accept: 'text/html' } })
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector('.shopify-section');
        if (el && this.panel) this.panel.innerHTML = el.innerHTML;
      })
      .catch(() => {});
  }
}

document.querySelectorAll('[data-cart-hover]').forEach((root) => new CartHover(root));
